import { ScalingInLine } from '../../../../components/displays/charts/d3/candlestickchart/newCandleChart/softOrders/softOrderChartComponents/positionTactics/ScalingInLine';
import { ScalingInTacticPanel } from '../../../../components/displays/tradeplans/activeTradePlanModule/components/detailsSection/individualTacticPanels/positions/scalingIn/ScalingInTacticPanel';
import { ScalingInWrapper } from '../../../../components/displays/tradeplans/softOrderModules/positionTacticModules/ScalingInModule/wrapper/ScalingInWrapper';
import ScalingInDocs from '../../../../components/forms/tradeplans/documentation/ScalingInDocumentation';
import ScalingInModule from '../../../../components/forms/tradeplans/tradingPlanFormComponents/FieldComponents/positionTactics/modules/ScalingInModule';
import { ScalingInData } from './scalingInData';
import { validateScalingIn } from './validateScalingIn';

export const ScalingIn = {
  //data class
  dataStore: ScalingInData,

  //string constants
  name: 'SCALING_IN',
  tacticLabel: 'Scaling In',
  addTacticLabel: 'Add Scaling In',
  category: 'Position',

  // components
  tradePlanFormModule: ScalingInModule,
  tacticPanel: ScalingInTacticPanel,
  addTacticPanel: null,
  wrapper: ScalingInWrapper,
  chartSoftOrderComponent: ScalingInLine,
  documentation: ScalingInDocs,
  alertDetailsComponent: null,

  //functions
  setupDetailParser: null, //todo
  validationFunction: validateScalingIn,
};
